import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

import { Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import {
  useLocationDisplayFromContext,
  LocationDisplayType,
} from "../../../../utils/locationUtils";
import { JobLocation } from "../JobLocation";

const styles = StyleSheet.create({
  preciseLocationWrapper: {
    width: "100%",
  },
  locationContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  locationText: {
    color: colors.neutral[1000],
  },
});

export function LocationSection() {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const display = useLocationDisplayFromContext({ allowRemoteWithoutInline: true });

  if (!viewjobOneGraphModel) {
    return null;
  }

  const { remoteWorkModel } = viewjobOneGraphModel.job;

  if (display.type === LocationDisplayType.LOCATION_WITH_REMOTE) {
    return (
      <Box sx={styles.locationContainer}>
        <Text level={3} sx={styles.locationText}>
          {display.resolvedLocation}
        </Text>
        <Text level={3} sx={styles.locationText}>
          •
        </Text>
        <Text level={3} sx={styles.locationText}>
          {remoteWorkModel?.text}
        </Text>
      </Box>
    );
  }

  if (display.type === LocationDisplayType.STREET_ADDRESS) {
    return <JobLocation />;
  }

  if (display.type === LocationDisplayType.LOCATION_ONLY) {
    return (
      <Text level={3} sx={styles.locationText}>
        {display.resolvedLocation}
      </Text>
    );
  }

  if (display.type === LocationDisplayType.REMOTE_ONLY) {
    return (
      <Text level={3} sx={styles.locationText}>
        {remoteWorkModel?.text}
      </Text>
    );
  }

  return null;
}
